var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-play-4906818",
    d: "M121.99,27.992a24,24,0,1,1-16.97,7.03,23.926,23.926,0,0,1,16.97-7.03Zm2.216,17.166,9.41,5.684a1.332,1.332,0,0,1,.016,2.291L114.84,64.485a1.334,1.334,0,0,1-2.081-1.1V40.6a1.334,1.334,0,0,1,2.021-1.141l9.426,5.7Zm12.869-8.25a21.335,21.335,0,1,0,6.248,15.085,21.266,21.266,0,0,0-6.248-15.085Z",
    transform: "translate(-97.99 -27.992)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayIcon);
export default __webpack_public_path__ + "static/media/video-play-icon.6d7ca6cbcb7ad131a322279e1b1769a1.svg";
export { ForwardRef as ReactComponent };